import { render } from "./InfoGeneralSettingDetail.vue?vue&type=template&id=ba4e9d24"
import script from "./InfoGeneralSettingDetail.vue?vue&type=script&lang=js"
export * from "./InfoGeneralSettingDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cargo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__